export interface MidnightVerificationSession {
    loadId: number;
    expectedAmount?: number;
    isRepost?: boolean;
    returnPath: string;
}

/** Firebase remote config: `mandatory_verification_amount_payment_window` */
export interface MidnightVerificationWindowConfig {
    is_enabled?: boolean;
    from_date?: string;
    to_date?: string;
    payment_start_time?: string;
    payment_end_time?: string;
}

export const MANDATORY_VERIFICATION_PAYMENT_WINDOW_KEY = "mandatory_verification_amount_payment_window";
